import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import expenseService from "./expenseDataService";
const expenseCreateData = JSON.parse(localStorage.getItem('expenseCreate'));

const initialState = {
  expTeam: null,
  expClient: null,
  expProject: null,
  expDepartment: null,
  filterExpCategory: null,
  filterExpCurrency: null,
  filterExpStatus: null,
  expenseCreate: expenseCreateData ? expenseCreateData : null,
  // expenseUpdate: false,
};

export const setExpTeam = createAsyncThunk("expense/team", async (expTeam) => {
  return expTeam;
});

export const setExpClient = createAsyncThunk(
  "expense/client",
  async (expClient) => {
    return expClient;
  }
);

export const setExpProject = createAsyncThunk(
  "expense/project",
  async (expProject) => {
    return expProject;
  }
);

export const setExpDepartment = createAsyncThunk(
  "expense/department",
  async (expDepartment) => {
    return expDepartment;
  }
);

export const setFilterExpCategory = createAsyncThunk(
  "expense/category",
  async (filterExpCategory) => {
    return filterExpCategory;
  }
);

export const setFilterExpCurrency = createAsyncThunk(
  "expense/currency",
  async (filterExpCurrency) => {
    return filterExpCurrency;
  }
);

export const setFilterExpStatus = createAsyncThunk(
  "expense/status",
  async (filterExpStatus) => {
    return filterExpStatus;
  }
);

export const setExpenseData = createAsyncThunk('expense/setExpenseData', async (autoData) => {
  return await expenseService.expenseCreateData(autoData)
})

// export const setDate = createAsyncThunk("expense/date", async (date) => {
//   if (date != null) {
//     date.setHours(0, 0, 0, 0);
//     return date.toISOString();
//   } else {
//     return null;
//   }
// });

// export const expenseUpdate = createAsyncThunk(
//   "expense/expenseUpdate",
//   async (expenseUpdate) => {
//     return expenseUpdate;
//   }
// );

export const expenseSlice = createSlice({
  name: "expenseData",
  initialState,
  reducers: {
    reset: (state) => {
      state.expTeam = null;
      state.expClient = null;
      state.expProject = null;
      state.expDepartment = null;
      state.filterExpCategory = null;
      state.filterExpCurrency = null;
      state.filterExpStatus = null;
      state.expenseCreate = null;
    },
    setAllExpenseFilters: (state, action) => {
      const { expTeam, expClient, expProject, expDepartment, filterExpCategory, filterExpCurrency, filterExpStatus } = action.payload;
      if (expTeam !== undefined) state.expTeam = expTeam;
      if (expClient !== undefined) state.expClient = expClient;
      if (expProject !== undefined) state.expProject = expProject;
      if (expDepartment !== undefined) state.expDepartment = expDepartment;
      if (filterExpCategory !== undefined) state.filterExpCategory = filterExpCategory;
      if (filterExpCurrency !== undefined) state.filterExpCurrency = filterExpCurrency;
      if (filterExpStatus !== undefined) state.filterExpStatus = filterExpStatus;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setExpTeam.fulfilled, (state, action) => {
      state.expTeam = action.payload;
    });
    builder.addCase(setExpClient.fulfilled, (state, action) => {
      state.expClient = action.payload;
    });
    builder.addCase(setExpProject.fulfilled, (state, action) => {
      state.expProject = action.payload;
    });
    builder.addCase(setExpDepartment.fulfilled, (state, action) => {
      state.expDepartment = action.payload;
    });
    builder.addCase(setFilterExpCategory.fulfilled, (state, action) => {
      state.filterExpCategory = action.payload;
    });
    builder.addCase(setFilterExpCurrency.fulfilled, (state, action) => {
      state.filterExpCurrency = action.payload;
    });
    builder.addCase(setFilterExpStatus.fulfilled, (state, action) => {
      state.filterExpStatus = action.payload;
    });
    builder.addCase(setExpenseData.fulfilled, (state, action) => {
      state.expenseCreate = action.payload
    })
    // builder.addCase(setDate.fulfilled, (state, action) => {
    //   state.date = action.payload;
    // });
    // builder.addCase(setPerPage.fulfilled, (state, action) => {
    //   state.perPage = action.payload;
    // });
    // builder.addCase(expenseUpdate.fulfilled, (state, action) => {
    //   state.expenseUpdate = action.payload;
    // });
  },
});

export const { reset, setAllExpenseFilters } = expenseSlice.actions;
export default expenseSlice.reducer;
